// extracted by mini-css-extract-plugin
export default {"form":"Newsletter_form__3uBWD","forms":"Newsletter_forms__WU+f-"};